import { render, staticRenderFns } from "./MovieListPh.vue?vue&type=template&id=1c6f12e4&scoped=true&"
import script from "./MovieListPh.vue?vue&type=script&lang=js&"
export * from "./MovieListPh.vue?vue&type=script&lang=js&"
import style0 from "./MovieListPh.vue?vue&type=style&index=0&id=1c6f12e4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6f12e4",
  null
  
)

export default component.exports